import { createApp } from 'vue'
import App from './App.vue'

require("./assets/main.css");

createApp(App).mount('#app')
